angular.module('Itao.IndicatorMap').directive('setRefPointBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var colors = [];
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function (d, i) {
    return i;
  };

  var innerColor = function(d) {
    return accessor('color')(d);
  };

  var whiteToOpacity = function(d){
    if(d != null && d.color != null) {
      return d.color.toLowerCase() === '#ffffff' ? 0 : 1;
    } else {
      return 1;
    }
  };

  var combineData = function (layer, selectedIndicatorSet, disabledDistrictKeys, colorset, legend) {

    var indicators = selectedIndicatorSet.indicators.filter(function(indicator){
      return indicator.list === false;
    }).sort(function(a,b){
      return a.listIndex - b.listIndex;
    }).slice(0,2);

    return Object.keys(layer.districts).filter(function(districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    }).map(function(districtUid) {
      var districtData = {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name,
        hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
        barValue: {
          value: null
        },
        refValue: {
          value: null
        }
      };

      if(indicators.length < 2) {
        return districtData;
      }

      var refHasLegendText = (legend != null && legend.chart != null && legend.chart.scales[0] != null && legend.chart.scales[0].text !== '');
      var barHasLegendText = (legend != null && legend.chart != null && legend.chart.scales[1] != null && legend.chart.scales[1].text !== '');

      if(layer[districtUid] && layer[districtUid][indicators[0].uid] != null) {
        districtData.refValue = {
          value:(+layer[districtUid][indicators[0].uid]),
          name:  refHasLegendText ? legend.chart.scales[0].text : indicators[0].name,
          unit: indicators[0].unit,
          prefix: indicators[0].prefix,
          color: colorset[0],
          key: layer.districts[districtUid].key
        };
      }
      if(layer[districtUid] && layer[districtUid][indicators[1].uid] != null) {
        districtData.barValue = {
          value:(+layer[districtUid][indicators[1].uid]),
          unit: indicators[1].unit,
          name:  barHasLegendText ? legend.chart.scales[1].text : indicators[1].name,
          prefix: indicators[1].prefix,
          color: colorset[1],
          key: layer.districts[districtUid].key
        };
      }
      return districtData;
    });
  };

  var setRefPointBarChart = function () {
    var defaultIndicator = {},
      svgHeight = 200,
      displayValues = false,
      margin = {top: 40, right: 40, bottom: 30, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      refTip,
      redLines,
      decimals,
      maxAxisValue,
      barTip;

    var chart = function (selection) {
      selection.each(function (data) {
        var maxDomainValue;
        var yAxisFormatter = decimals ? germanNumberFormat(',.'+decimals+'f') : germanNumberFormat(',');
        //var yFormatter = germanNumberFormat(',.'+(defaultIndicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces)+'f');

        var container = d3.select(this).datum([data]).classed('set-ref-point-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(refTip)) {
          refTip.destroy();
        }
        if (angular.isDefined(barTip)) {
          barTip.destroy();
        }

        barTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d,i,j) {
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var featureData = values[j].parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + germanNumberFormat(',.'+decimals+'f')(d.value)+'</span></div>';
          });

        refTip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d,i,j) {
            if(!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            var featureData = values[j].parentNode.__data__;
            return '<div class="d3-tip-border" style="border-color:#000000;"><b>' + featureData.name + ' (' + featureData.key + ')</b><br><span style="color:#000000;">' + d.name.replace(/<[^>]*>?/gm, '').trim() + ':</span> <span class="tooltip-value">' + d.prefix + germanNumberFormat(',.'+decimals+'f')(d.value)+'</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);
        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('.margin-group').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        var featureScale = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.4)
          .domain(data.map(accessor('key')));

        if(maxAxisValue) {
          maxDomainValue = maxAxisValue;
        } else if(mapConfig.axisMaxValue != null) {
          maxDomainValue = mapConfig.axisMaxValue;
        } else {
          maxDomainValue = d3.max(data.map(function(d) {return Math.max(d.barValue.value, d.refValue.value);}));
        }

        var barScale = d3.scale.linear()
          .domain([0,maxDomainValue])
          .range([height,0]);

        var tickCount = Math.min(svgHeight / 40, 10);

        var yAxis = d3.svg.axis()
          .scale(barScale)
          .ticks(tickCount)
          .tickFormat(function(d){
            return defaultIndicator.prefix + yAxisFormatter(d).replace('%','');
          })
          .orient('left');

        var xAxis = d3.svg.axis()
          .scale(featureScale)
          .orient('bottom');

        redLines = redLines ? redLines : mapConfig.redLines;

        g.call(d3.hyperion.addHorizontalGridLines(barScale, width, 0, tickCount, duration));
        // g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));
        g.call(d3.hyperion.addHorizontalHighlightArea(redLines, barScale, featureScale, width, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function(d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function(d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis);

        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate('+(margin.left-7)+', 10)');

        svg.select('.axis-unit-label')
          .text(defaultIndicator.unit === '%' ? 'in %' : '');

        var features = g.selectAll('.feature')
          .data(data, accessor('key'));

        features.enter()
          .append('g')
          .classed('feature', true)
          .attr('transform', function(d){
            return 'translate(' + featureScale(accessor('key')(d)) +',0)';
          });

        features
          .transition().duration(duration)
          .attr('transform', function(d){
            return 'translate(' + featureScale(accessor('key')(d)) +',0)';
          });



        var values = features.selectAll('.value')
          .data(function(d){return (d != null && d.barValue != null && d.barValue.value != null) ? [d.barValue] : [];}, accessor('key'));

        values.enter()
          .append('rect')
          .attr('class', 'value')
          .attr('x', 0)
          .attr('width', featureScale.rangeBand())
          .attr('fill', accessor('color'))
          .attr('y', barScale(0))
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', 0);

        values.transition().duration(duration)
          .attr('fill', accessor('color'))
          .attr('fill-opacity', whiteToOpacity)
          .attr('height', function(d){
            return height - barScale(d.value);
          })
          .attr('y', function(d) {
            return barScale(d.value);
          })
          .attr('width', featureScale.rangeBand());

        if(values.size() > 0) {
          values.call(barTip);
          values.on('mouseover', function(d,i,j){
            if(d.color.toLowerCase() !== '#ffffff') {
              barTip.show(d,i,j);
            }
          }).on('mouseout', function(d){
            if(d.color.toLowerCase() !== '#ffffff') {
              barTip.hide(d);
            }
          });
        }

        var labels = features.selectAll('text.chart-value')
          .data(function(d){return (d != null && d.barValue != null && d.barValue.value != null) ? [d.barValue] : [];}, accessor('key'));

        if(displayValues) {
          labels.enter()
            .append('text')
            .attr('class', 'chart-value')
            .attr('y', 0);

          // update labels
          labels
            .attr("class", "chart-value")
            .text(function (d) {
              return germanNumberFormat('.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(accessor('value')(d));
            })
            .attr('y', function(d,i,j){
              // return height - barScale(d.offset/values[j].parentNode.__data__.sum)+12;
              return barScale(d.value) - 4;
            })
            .attr('x', function(d, i) {
              // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
              return (featureScale.rangeBand()/2);
            });

          // remove unused labels
          labels.exit()
            .remove();
        } else {
          labels
            .remove();
        }

        values.exit().transition().duration(duration)
          .attr('width', 0)
          .attr('height', 0)
          .remove();

        var refPoints = features.selectAll('.refpoint')
          .data(function(d){return (d != null && d.refValue != null && d.refValue.value != null) ? [d.refValue] : [];}, accessor('key'));

        refPoints.enter()
          .append('circle')
          .attr('class', 'refpoint')
          .attr('cx', featureScale.rangeBand() / 2)
          .attr('r', (featureScale.rangeBand() / 2) - 4)
          .attr('fill', accessor('color'))
          .attr('cy', barScale(0))
          .attr('fill-opacity', whiteToOpacity);

        refPoints.transition().duration(duration)
          .attr('fill', accessor('color'))
          .attr('fill-opacity', whiteToOpacity)
          .attr('cy', function(d) {
            return barScale(d.value);
          })
          .attr('cx', featureScale.rangeBand() / 2)
          .attr('r', (featureScale.rangeBand() / 2) - 4);

        if(refPoints.size() > 0) {
          refPoints.call(refTip);
          refPoints.on('mouseover', function(d,i,j){
            if(d.color.toLowerCase() !== '#ffffff') {
              refTip.show(d,i,j);
            }
          }).on('mouseout', function(d){
            if(d.color.toLowerCase() !== '#ffffff') {
              refTip.hide(d);
            }
          });
        }

        refPoints.exit().transition().duration(duration)
          .attr('r', 0)
          .remove();

        var refPointLabels = features.selectAll('text.ref-value')
          .data(function(d){return (d != null && d.refValue != null && d.refValue.value != null) ? [d.refValue] : [];}, accessor('key'));


        g.selectAll('line.highlightLine').remove();
        g.call(d3.hyperion.addHorizontalHighlightLines(redLines, barScale, width, duration));

        if(displayValues) {
          refPointLabels.enter()
            .append('text')
            .attr('class', 'ref-value')
            .attr('y', 0);

          // update labels
          refPointLabels
            .text(function (d) {
              return germanNumberFormat('.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(accessor('value')(d));
            })
            .attr('y', function(d,i,j){
              return barScale(d.value) + (((featureScale.rangeBand() / 2) - 5)/2);
            })
            .attr('x', function(d, i) {
              // return (featureScale.rangeBand()/2) + (featureScale.rangeBand()* i);
              return (featureScale.rangeBand()/2);
            });

          // remove unused labels
          refPointLabels.exit()
            .remove();
        } else {
          refPointLabels
            .remove();
        }

        features.exit().remove();
      });
    };

    /**
     * getter/setter for defaultIndicator
     * @param {Array} [newDefaultIndicator] set of new defaultIndicator
     * @returns {*}
     */
    chart.defaultIndicator = function (newDefaultIndicator) {
      if (!arguments.length) {
        return defaultIndicator;
      } else {
        defaultIndicator = newDefaultIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function(newDisplayValues) {
      if(!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function(newRedLines) {
      if(!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return refTip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element, absolute) {
    var content = element.closest('.grid-stack-item-content-setRefPointBarChart');
    return content.height() - jQuery(content).find('.selected-indicator-set').height() - jQuery(content).find('.no-indicator-set-selected').height() - 20;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setRefPointBarChart.html',
    scope: {
      layer: '=',
      indicators: '=',
      colorsets: '=',
      useAbsoluteValues: '@',
      indicatorSets: '=',
      disabledDistrictKeys: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.selectedIndicatorSet = scope.config.selectedIndicatorSet || null;
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.indicatorSetToShow = scope.config.selectedIndicatorSet;
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var setRefPointBarChartFunction = setRefPointBarChart();

      var useAbsoluteValues = scope.useAbsoluteValues === '1';

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if (newHeight == null) {
          newHeight = calculateChartHeight(element, useAbsoluteValues);
        }

        var indicators = scope.indicators;
        var redLines = null;
        var decimals = null;
        var maxAxisValue = null;
        scope.selectedIndicatorSet = [];
        if (angular.isArray(indicators) && indicators.length > 0 && indicators[0].isDefault) {
          // first selected indicator belongs to an indicatorSet
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });
          if (selectedSets.length > 0) {
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);
            var colorset = d3.hyperion.indicatorColors;
            var legend = null;
            if(scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              colorset = scope.colorsets.filter(function(colorset) {
                return (+colorset.uid) === (+scope.layer.legend[defaultIndicatorUid].chart.colorSet);
              })[0].colors.map(function(color) {return color.color;});

              legend = scope.layer.legend[defaultIndicatorUid];

              if (legend && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if(legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }
            }

            var data = combineData(scope.layer, scope.selectedIndicatorSet, scope.disabledDistrictKeys, colorset, legend);

            setRefPointBarChartFunction
              .defaultIndicator(scope.selectedIndicatorSet.defaultIndicator)
              .displayValues(scope.config.displayValues)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .height(newHeight);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data])
              .call(setRefPointBarChartFunction);
          } else {
            scope.config.selectedIndicatorSet = null;
            d3.select(element[0]).select('svg').remove();
          }
        }
      };

      jQuery(document).on("fullscreen", rerender);

      var layerWatcher = scope.$watchCollection('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var indicatorSetWatcher = scope.$watchCollection('indicatorSets', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var districtLabelPropertyWatcher = scope.$watch('config.districtLabelProperty', rerender);
      var selectedIndicatorSet = scope.$watch('indicatorSetToShow', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        indicatorSetWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        selectedIndicatorSet();
        districtLabelPropertyWatcher();
        fullscreenWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();
        // remove tooltip dom element
        if (angular.isDefined(setRefPointBarChartFunction.tip())) {
          setRefPointBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
